import React from 'react';
import {Field, FieldDescription, FieldError, FieldLabel} from "@root/server/client/esweb/components/ui/field";
import {Control, Controller, FieldPath} from "react-hook-form";
import {Textarea} from "@root/server/client/esweb/components/ui/textarea";

let ix = 0;

export function RhfTextarea<FORM_TYPE>(params: {
    name: FieldPath<FORM_TYPE>
    label: string,
    control: Control<FORM_TYPE>,
    textareaProps: Record<string, string>
}) {
    const id = `rhftextarea-${ix++}`;

    const {
        name,
        label,
        control,
        textareaProps
    } = params;

    return <Controller
        {...{name, control}}
        render={({ field, fieldState }) => (
            <Field data-invalid={fieldState.invalid}>
                <FieldLabel htmlFor={id}>
                    {label}
                </FieldLabel>
                <Textarea
                    {...field as {}}
                    id={id}
                    aria-invalid={fieldState.invalid}
                    className="min-h-[120px]"
                    {...textareaProps}
                />
                {/*<FieldDescription>*/}
                {/*    Tell us more about yourself. This will be used to help us*/}
                {/*    personalize your experience.*/}
                {/*</FieldDescription>*/}
                {fieldState.invalid && (
                    <FieldError errors={[fieldState.error]} />
                )}
            </Field>
        )}
    />
}